import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ID } from '@gh/common-shared-data';
import { NotificationService, STYLES_DIALOG_LAYOUT, WaitingService } from '@gh/core-ui';
import { LeadRestService, SalesFolderStatus, BulkEditLeadsDto } from '@gh/builder-shared-data';
import { Enum } from '@gh/core-data';

@Component({
  standalone: false,
  selector: 'gh-bulk-edit-leads-dialog',
  templateUrl: 'bulk-edit-leads-dialog.component.html',
  styleUrls: ['bulk-edit-leads-dialog.component.scss'],
  styles: [STYLES_DIALOG_LAYOUT],
})
export class BulkEditLeadsDialogComponent implements OnInit {
  selectedStatus?: number;
  selectedReason?: number;
  selectedStage?: number;
  selectedPriority?: number;
  
  statusNotProceeding: number = Enum.toValue(SalesFolderStatus, SalesFolderStatus.WillNotComplete);
  
  statuses = [
    { id: Enum.toValue(SalesFolderStatus, SalesFolderStatus.Active), name: 'Active' },
    { id: Enum.toValue(SalesFolderStatus, SalesFolderStatus.WillNotComplete), name: 'Not Proceeding' }
  ];
  
  reasons: any[] = [];
  stages: any[] = [];
  priorities: any[] = [];
  
  contactIds: ID[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<BulkEditLeadsDialogComponent>,
    private leadRest: LeadRestService,
    private notificationService: NotificationService,
    private waiting: WaitingService
  ) {
    this.contactIds = data.contactIds;
    this.reasons = data.reasons;
    this.stages = data.stages.map((s: any) => ({ id: parseInt(s.itemCode), name: s.localization }));
    this.priorities = data.priorities.map((p: any) => ({ id: parseInt(p.itemCode), name: p.localization }));
  }

  ngOnInit(): void {}

  onStatusChange(): void {
    if (this.selectedStatus !== this.statusNotProceeding) {
      this.selectedReason = undefined;
    }
  }

  isSaveDisabled(): boolean {
    const nothingSelected = !this.selectedStatus && !this.selectedStage && !this.selectedPriority;
    const reasonRequiredAndMissing = this.selectedStatus === this.statusNotProceeding && !this.selectedReason;
    return nothingSelected || reasonRequiredAndMissing;
  }

  onSave(): void {
    const request: BulkEditLeadsDto = {
      contactIds: this.contactIds,
      status: this.selectedStatus,
      notProceedingReasonId: this.selectedReason,
      stageId: this.selectedStage,
      priorityId: this.selectedPriority
    };

    this.leadRest.bulkEdit(request)
      .pipe(this.waiting.operator())
      .subscribe((res: any) => {
        if (res && res.async) {
          this.notificationService.success('msg_bulk_edit_leads_task_added');
        } else {
          this.notificationService.success('msg_bulk_edit_leads_success');
        }
        this.dialogRef.close(true);
      }, (err) => {
        if (err.error && err.error.message === 'msg_bulk_edit_no_changes') {
          this.notificationService.error('msg_bulk_edit_no_changes');
          this.dialogRef.close();
        } else {
          this.notificationService.processAll(err);
        }
      });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
